






import { Component, Vue } from "vue-property-decorator";

@Component
export default class MirrorBookViewer extends Vue {
  public title = "";
  public content = "";
  public srcdoc = "";

  private iframeLoaded = false;
  private channel = new BroadcastChannel("book-mirror");

  mounted() {
    this.channel.onmessage = (event: MessageEvent) => {
      const { title, content, scrollRatio } = event.data;

      let contentChanged = false;

      if (title !== undefined && title !== this.title) {
        this.title = title;
        contentChanged = true;
      }

      if (content !== undefined && content !== this.content) {
        this.content = content;
        contentChanged = true;
      }

      if (contentChanged) {
        this.iframeLoaded = false; // iframe will reload
        this.updateSrcdoc();
      }

      if (scrollRatio !== undefined) {
        this.$nextTick(() => {
          if (!this.iframeLoaded) {
            const unwatch = this.$watch("iframeLoaded", (loaded) => {
              if (loaded) {
                this.sendScrollToIframe(scrollRatio);
                unwatch();
              }
            });
          } else {
            this.sendScrollToIframe(scrollRatio);
          }
        });
      }
    };
  }

  beforeDestroy() {
    this.channel.close();
  }

  private onIframeLoaded() {
    this.iframeLoaded = true;
    this.injectScrollHandlerIntoIframe();
  }

  private sendScrollToIframe(scrollRatio: number) {
    const iframe = this.$refs.iframe as HTMLIFrameElement;
    iframe?.contentWindow?.postMessage({ type: "scrollTo", scrollRatio }, "*");
  }

  private injectScrollHandlerIntoIframe() {
    const iframe = this.$refs.iframe as HTMLIFrameElement;
    const win = iframe?.contentWindow;
    if (!win) return;

    try {
      win.addEventListener("message", (event) => {
        const data = event.data;
        if (data?.type === "scrollTo" && typeof data.scrollRatio === "number") {
          const maxScroll = win.document.body.scrollHeight - win.innerHeight;
          win.scrollTo(0, maxScroll * data.scrollRatio);
          console.log("Scroll handled in iframe (injected)", data.scrollRatio);
        }
      });
    } catch (e) {
      console.warn("Failed to inject scroll handler:", e);
    }
  }

  private updateSrcdoc(): void {
    this.srcdoc = `
      <!DOCTYPE html>
      <html lang="de">
        <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <link rel="stylesheet" href="https://wiki.drive.buzz/dist/styles.css?version=v24.05.2" />
          <style>
            html, body {
              margin: 0;
              padding: 1rem;
              box-sizing: border-box;
              width: 100%;
              min-height: 100%;
              overflow-y: auto;
              overflow-x: hidden;
              font-family: sans-serif;
              background: white;
            }
            body {
              padding-top: 0;
              padding-bottom: 0;
            }
            body::-webkit-scrollbar {
              display: none;
            }
            html { height: 100%; }
            body { height: auto; }
            *, *::before, *::after {
              box-sizing: inherit;
            }
            h1, h2, h3, h4, h5 {
              font-weight: bold;
              line-height: 1.4;
              margin-top: 20px;
              margin-bottom: 10px;
              color: #2c3e50;
            }
            h1 { font-size: 32px; }
            h2 { font-size: 28px; }
            h3 { font-size: 24px; }
            h4 { font-size: 20px; }
            h5 { font-size: 18px; }
            img {
              max-width: 100%;
              height: auto;
              display: block;
              margin: 1rem auto;
            }
            p {
              margin-bottom: 1rem;
            }
            ul, ol {
              padding-left: 1.5rem;
              margin-bottom: 1rem;
            }
            .callout, .warning {
              border-left: 4px solid #ffc107;
              background-color: #fff8e1;
              padding: 1rem;
              margin: 1rem 0;
              border-radius: 4px;
            }
            th {
              font-weight: bold;
            }
          </style>
        </head>
        <body>
          <div>
            ${this.title ? `<h1>${this.title}</h1>` : ""}
            ${this.content}
          </div>
          </body>
          </html>
          `;
  }
}
